import getLangLocale from 'I18n/utils/getLangLocale';
import { useQuery } from 'data-fetching-client';
import { GET_PRIORITY_FEATURES_QUERY } from '../../../../../__generated__/chirp/com/hubspot/feature/store/rpc/PriorityFeaturesRpc.dfc.new';
import { useProductDetails } from '../../../hooks/product/useProductDetails';
const usePriorityFeaturesForApiName = ({
  productApiName
}) => {
  const {
    data,
    loading
  } = useQuery(GET_PRIORITY_FEATURES_QUERY, {
    variables: {
      productApiName,
      i18nLangLocale: getLangLocale()
    }
  });
  return {
    priorityFeatures: (data === null || data === void 0 ? void 0 : data.result.priorityFeatures) || [],
    loading
  };
};
export const useCategorizedPriorityFeatures = ({
  productApiName
}) => {
  const {
    loading,
    priorityFeatures: features
  } = usePriorityFeaturesForApiName({
    productApiName
  });
  const brandingAndLimitFeatures = features.filter(feature => feature.featureType === 'LIMIT_INCREASE' || feature.featureType === 'REMOVE_BRANDING');
  const uncategorizedFeatures = features.filter(feature => !feature.featureType);
  return {
    loading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  };
};
export const useIncludedContacts = ({
  productApiName
}) => {
  const {
    productDetails,
    loading
  } = useProductDetails({
    productApiName
  });
  const includedContacts = (productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantitiesMap['CONTACTS']) || null;
  return {
    includedContacts,
    loading
  };
};